export const getLanguageForApi = (language: string) => language.replace(/-.*/, '');
